/**
 * Parcels Receipt
 */

// React
import React, { useEffect, useState } from 'react';
import { chunk } from 'lodash';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';

// Helper
import { useQuery, translate } from '../../utils/helpers';

// Type
import { PrintProps } from '../orderDetails/interfaces';

import { Order } from './interfaces';
import { useLocation } from 'react-router-dom';
import Barcode from 'react-barcode';
import handleError from '../../utils/handleError';
// apis
import { GetPickListRequestBuilder } from 'client-sdk/src/orders/orders';
import Client from 'client-sdk/src/client';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import jMoment from 'moment-jalaali';
import showDeliveryType from '../../utils/temporaryConditions/showDeliveryType';
import showOrderTplType from '../../utils/temporaryConditions/showOrderTplType';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function Details(props: PrintProps) {
  const classes = useStyles();
  const token = localStorage.getItem('token') || '';
  const [variants, setVariants] = useState<any>([]);
  const [fulfillmentName, setFulfillmentName] = useState<any>("");
  const [fulfillmentFound, setFulfillmentFound] = useState<boolean>(false);
  const [orderList, setOrderList] = useState<Order[]>([]);
  const [orders, setOrders] = useState<any>([]);
  const query = useQuery(useLocation);
  useEffect(() => {
    if (orderList.length > 0) {
      setTimeout(() => {
        window.print();
      }, 1000)
    }
  }, [orderList]);
  const getOrdersPrint = async (actions: any) => {
    const payload = { ...actions }
    try {
      const response = await ordersRepository.getOrdersPrint({ payload });
      setOrders(response.data);
    } catch (error) {
      handleError(error.response);
    }
  }

  useEffect(() => {
    fetchUnits();
    getOrdersPrint({
      id: { in: query.get('ids') },
      size: 200
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchUnits = async () => {
    try {
      const makeRequest = new GetPickListRequestBuilder()
        .params({ points: query.get('ids') })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeRequest);
      setVariants(data);
    } catch (err) {
      //
    }
  };



  useEffect(() => {
    if (orders.length) {
      splitOrders();
    }

    // console.log(orders);
    // orders.map(item => console.log(item.fulfillmentLineName));
    if (fulfillmentFound === false) {

    }
    orders.map(item => {
      setFulfillmentName(item.fulfillmentLineName);
      setFulfillmentFound(true);
    }
    );

  }, [orders]);

  const splitOrders = () => {
    const newOrders = [...orders];
    const orderList: Order[] = [];
    newOrders.forEach((order: Order, i) => {
      if (order.items.length > 4) {
        const lists: Order[] = [];
        chunk(order.items, 10).forEach(el => {
          let or = { ...order };
          or.items = el;
          lists.push(or);
        });
        orderList.push(...lists);
      } else {
        orderList.push(order);
      }
    });
    setOrderList(orderList);
  };

  return (
    <WrapperReceipt className={classes.root}>
      {orderList?.map((order: Order) => (
        <div className="page">
          <div className="logo-box">
            <div>
              <div>
                <img src="/logo.png" alt="" height="30"/>
              </div>
              <div>
                <b>
                  کد پیگیری:&nbsp;</b><span>
                  {order.trackingCode}
                </span>
              </div>
              <div>
                <b>
                  نام مشتری:&nbsp;</b><span className='text-bold'>
                  {order.customerName}
                </span>
              </div>
            </div>
            <div>
              <p className='numbers'><span>
                    {jMoment(order.deliveryDate, 'YYYY/M/D')
                      .locale('fa')
                      .format('jYY/jMM/jDD')}
                  </span>
                  &nbsp; -  &nbsp;
                  <span>
                    {`${jMoment(order.deliveryStartTime, 'HH:mm:ss')
                      .locale('fa')
                      .format('HH')}
                    `}
                    {`تا ${jMoment(order.deliveryEndTime, 'HH:mm:ss')
                      .locale('fa')
                      .format('HH')}`}
              </span></p>
              <p className='numbers'>{showDeliveryType(order.deliveryType)}{`(${showOrderTplType(order.deliveryType, order.orderTplType)})`}</p>
              <p className='numbers'> {translate(order.fulfillmentLineId)}</p>
            </div>
            <span>
              <Barcode height={'50px'} fontSize={9} value={order?.id} />
            </span>
          </div>
          {/* <div className="address-box">
            <div>
              <b>
                آدرس مشتری:&nbsp;</b><span>
                {order.customerAddress}
              </span>
            </div>
          </div> */}
          <div className=" wrapper">
            <div className="title" style={{ marginTop: '15px' }}>
              <span>
                تعداد آیتم‌های سفارش:{' '}
                {orders?.find((el: Order) => el.id === order.id)?.items.length}
              </span>
              <span>شناسه سفارش: {variants[0]?.orderParentId ? variants[0]?.orderParentId : order?.id}</span>
            </div>

            <div className="card-b">
              <div className="card-b_box">
                <div className="card-b_header-box">
                  <div className="card-b_header">
                    <div
                      className="card-b_header-item"
                      style={{ maxWidth: '45px' }}
                    >
                      ردیف
                    </div>
                    <div className="card-b_header-item">نام کالا</div>
                    <div className="card-b_header-item">شناسه کالا</div>
                    <div
                      className="card-b_header-item"
                      style={{ maxWidth: '45px' }}
                    >
                      تعداد
                    </div>
                    <div className="card-b_header-item">واحد ها</div>
                  </div>
                </div>
                <div className="card-b_content">
                  {order?.items?.map((item: any, i) => {
                    let variantName = item.productName;
                    if (item.featureAndValues) {
                      for (
                        let i = 0;
                        i <= 2 && item?.featureAndValues[i];
                        i++
                      ) {
                        variantName = variantName.concat(
                          ' - ',
                          item.featureAndValues[i].key,
                          ' : ',
                          item.featureAndValues[i].value
                        );
                      }
                    }

                    if (item.sellerName || item.providerName) {
                      const sellerName = item.sellerName ?? item.providerName;
                      variantName = variantName.concat(' ( ', sellerName, ' )');
                    }
                    return (
                      <div key={i} className="card-b_content-row">
                        <div
                          className="card-b_content-item"
                          style={{ maxWidth: '45px' }}
                        >
                          {i + 1}
                        </div>
                        <div className="card-b_content-item">{variantName}</div>
                        <div className="card-b_content-item">
                          {item.variantId}
                        </div>
                        <div
                          className="card-b_content-item"
                          style={{ maxWidth: '45px' }}
                        >
                          {item.amount}
                        </div>
                        <div className="card-b_content-item">
                          {variants.length > 0
                            ? variants
                              .find((el: any) => el.orderId === order.id)
                              ?.orderItems.find(
                                orderItem =>
                                  orderItem.orderItemId === item.id
                              )
                              ?.units.join('/')
                            : 'ناموجود'}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </WrapperReceipt>
  );
}

export default Details;
